import axios from "axios";

const REPRINT_URL = `${process.env.REACT_APP_API_URL}tickets/printedStatus`

const onPrint = (printType, ticketId) => (
    axios.put(REPRINT_URL, {
        printType, ticketId
    })
)

export {onPrint}